module.exports = __webpack_public_path__ + "static/media/omdb-movies-combined-ipad.841ae6b0.png";